export const eur = (n) => { const [i, d] = (n || 0).toFixed(2).split("."); return `${i.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${d} €`; };
export const num = (v) => parseFloat(String(v).replace(",", ".")) || 0;
export const money = (v) => num(String(v ?? "").replace(/[€\s]/g, "").replace(/\.(?=\d{3}(\D|$))/g, ""));
export const it2 = (n) => (n ? String(Math.round(n * 100) / 100).replace(".", ",") : "");
export const fix2 = (v) => (String(v ?? "").trim() ? money(v).toFixed(2).replace(".", ",") : "");
export const STD_MATERIALS = ["Base", "Trasparente", "Pastello", "Fondo", "Varie"];

// € amount written inside an old-style quantity ("€ 25", "0,5 lt = 16,00 €")
const eurInQty = (q) => { const m = [...String(q ?? "").matchAll(/€\s*([\d.]+(?:,\d+)?)|([\d.]+(?:,\d+)?)\s*€/g)].pop(); return m ? num((m[1] || m[2]).replace(/\.(?=\d{3})/g, "")) : 0; };
export const materialEur = (r) => (String(r.price ?? "").trim() ? money(r.price) : eurInQty(r.qty));
export const partQty = (r) => (String(r.qty ?? "").trim() ? num(r.qty) : 1);
export const partEur = (r) => Math.round(partQty(r) * money(r.price) * 100) / 100;
const sum = (rows, f) => Math.round(rows.reduce((a, r) => a + f(r), 0) * 100) / 100;
export const materialsTotal = (rows) => sum(rows, materialEur);
export const partsTotal = (rows) => sum(rows, partEur);

// Saved consuntivo materials merged with what the operator sheets report
export const buildMaterials = (data) => {
  const fromSheets = data.hours.materials || {};
  const base = data.final.materials.length || data.job.final ? data.final.materials : STD_MATERIALS.map((m) => ({ description: m, qty: "", price: "" }));
  const key = (r) => r.description.trim().toLowerCase();
  const live = data.job.status !== "closed";
  const cost = data.hours.materials_cost || {};
  const materials = base.map((r) => {
    const k = key(r);
    if (r.edited || !fromSheets[k] || !(live || !r.qty)) return { price: "", ...r };
    return { ...r, qty: fromSheets[k], price: r.price || it2(cost[k]) };
  });
  Object.entries(fromSheets).forEach(([k, q]) => { if (!materials.some((r) => key(r) === k)) materials.push({ description: k[0].toUpperCase() + k.slice(1), qty: q, price: it2(cost[k]) }); });
  return materials;
};

// Parts listed on the acceptance sheet + extra rows saved in the consuntivo, each with qty and unit price
export const buildParts = (data) => {
  const saved = (data.final.parts || []).map((p) => ({ ...p }));
  const lines = (data.job.parts || "").split("\n").map((l) => l.trim()).filter(Boolean);
  const has = (l) => saved.some((p) => p.description.trim().toLowerCase() === l.toLowerCase());
  lines.forEach((l) => { if (!has(l)) saved.push({ description: l, qty: "1", price: "" }); });
  return saved.map((p) => ({ ...p, fromSheet: lines.some((l) => l.toLowerCase() === p.description.trim().toLowerCase()) }));
};
